"use strict";

var _Object$defineProperty2 = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty2(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _set = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set"));
var _entries = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/entries"));
var _defineProperty = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-property"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
var _cloneDeep = _interopRequireDefault(require("lodash/cloneDeep"));
var _get = _interopRequireDefault(require("lodash/get"));
/**
 * @file General functions use to determine access rights for a validated user
 *       using an OIDC access token. NOTE: Will soon be deprecated.
 */

/** easy mappings for common access paths */
const aliases = {
  resources: {
    read: ['resources-service', 'resources', 'read'],
    write: ['resources-service', 'resources', 'write']
  },
  vss: {
    read: ['vehicle-state-service', 'stream', 'read']
  },
  geofence: {
    read: ['geofence-crud-service', 'geofence', 'read'],
    write: ['geofence-crud-service', 'geofence', 'write']
  },
  mqs: {
    read: ['metrics-query-service', 'query', 'read']
  },
  alerts: {
    read: ['metrics-query-service', 'alerts', 'read']
  },
  bqs: {
    read: ['behavior-query-service', 'query', 'read']
  },
  sla: {
    write: ['sla-service', 'entry', 'write'],
    approve: ['sla-service', 'approval', 'write']
  }
};

/**
 * Ability map handler ensures false is returned if the ability DNE.  This is
 * done so the API is consistent with Access instance has().
 */
const abilityMapHandler = {
  get(target, name) {
    return name in target ? target[name] : false;
  }
};
const nullSet = new _set.default();
class Access {
  constructor(token) {
    this.token = token;

    // map aliases to objects to ones that will call this instance's has()
    const aliasMap = {};
    for (let [alias, abilities] of (0, _entries.default)(aliases)) {
      const abilityMap = {};
      for (let [ability, abilityPath] of (0, _entries.default)(abilities)) {
        (0, _defineProperty.default)(abilityMap, ability, {
          get: () => this.has(...abilityPath)
        });
      }
      aliasMap[alias] = new Proxy(abilityMap, abilityMapHandler);
    }

    // add alias properties to this instance
    for (let alias of (0, _keys.default)(aliases)) {
      (0, _defineProperty.default)(this, alias, {
        get: () => aliasMap[alias]
      });
    }
  }
  set token(token) {
    this._token = (0, _cloneDeep.default)(token);
    this._processToken();
  }

  /**
   * Maps the KC token to more susinct constant names since services can change names.
   */
  _processToken() {
    // making the assumption that every entry in the roles should be unique or
    // that duplicates have the same meaning
    this._access = {};
    for (let [resName, resAccess] of (0, _entries.default)(this._token.resource_access || [])) {
      // assuming roles is the only entry
      const roles = {};
      for (let role of resAccess.roles) {
        const [roleName, ability] = role.split(':');
        if (!roles[roleName]) {
          roles[roleName] = new _set.default();
        }
        roles[roleName].add(ability);
      }
      this._access[resName] = roles;
    }
  }

  /**
   * Returns true if a resource has a role with that ability.  Otherwise false.
   * @returns {boolean} true if resource roles ability exists
   */
  has(resName, role, ability) {
    return (0, _get.default)(this._access, [resName, role], nullSet).has(ability);
  }
}
exports.default = Access;